// Privacy Policy page (initial version – commented out)

import styles from './PrivacyAndPolicy.module.scss'

const PrivacyAndPolicy = () => {

    return (

<div className={styles.terms}>
    <div className="container">
        <h1>Privacy Policy (TfL / PCO Compliant)
</h1>

<p className={styles.terms__lastupdated}>
                    Last Updated: December 29, 2025
                </p>


                <div className={styles.terms__section}>
                    <h2>1. Introduction</h2>

                    <p>
                        Chauffeur Rides Ltd (“we”, “us”, “our”) is a Transport for London (TfL) licensed Private Hire Operator (PCO) providing chauffeur and private hire services in London and the surrounding areas.

                    </p>

                </div>

                <div className={styles.terms__section}>
                    <p>We are committed to protecting your personal data and handling it in accordance with:
</p>
 
<ul>
    <li>UK General Data Protection Regulation (UK GDPR)</li>
    <li>Data Protection Act 2018</li>
    <li>TfL Private Hire Operator licensing requirements</li>
</ul>

 <p>This Privacy Policy explains how we collect, use, store, and protect personal data.
</p>

                </div>

                <div className={styles.terms__section}>
                    <h2>2. Data Controller
</h2>



                </div>

                <p className={styles.terms__companyInfo}>
    <span>Company Name:</span> Chauffeur Rides Ltd

 </p>

 <p className={styles.terms__companyInfo}>
    <span>PCO Licence Number: </span>   11585



 </p>

 <p className={styles.terms__companyInfo}>
    <span>Registered Address: </span>   3 Gill crescent , DA117JJ 



 </p>

 <p className={styles.terms__companyInfo}>
    <span>Email: </span>   Chauffeurridesltd@hotmail.com 





 </p>

 <p className={styles.terms__companyInfo}>
    <span>Telephone: </span>    07943152288





 </p>

 <div className={styles.terms__section}>
    <h2>3. Personal Data We Collect
</h2>

<p>a) Passenger & Client Data
</p>

<ul>
    <li>Full name</li>
    <li>Telephone number</li>
    <li>Email address</li>
    <li>Pickup and drop-off locations</li>
    <li>Journey date, time, and distance</li>
    <li>Payment and billing details (processed securely by third-party providers)</li>
    <li>Special requirements (e.g. luggage, accessibility, child seats)</li>

    
</ul>

<p>b) Journey & Driver Allocation Data
 </p>
<ul>
    <li>	Assigned driver name and private hire driver licence number</li>
    <li>	Vehicle registration details</li>
    <li>Booking and journey logs required by TfL</li>

</ul>

<p>
    c) Website & Booking System Data

</p>
<ul>
    <li>IP address</li>
    <li>Browser and device information</li>
    <li>Booking system usage data</li>
    <li>Cookies (see Cookie Policy)</li>
</ul>

<p>d) CCTV / Dashcam Data (If Applicable)
</p>
 <ul>
    <li>Video and/or audio recordings inside or outside vehicles</li>
    <li>Date, time, and location of recording</li>
 </ul>
 </div>


 <div className={styles.terms__section}>
    <h2>4. How We Use Personal Data
</h2>

<p>We use personal data to:
</p>

<ul>

    <li>Accept and manage private hire bookings</li>
    <li>Allocate licensed drivers and vehicles</li>
    <li>Communicate booking information to passengers and drivers</li>
    <li>Provide chauffeur and private hire services</li>
    <li>Comply with TfL and PCO licensing obligations</li>
    <li>Maintain legally required booking and journey records</li>
    <li>Process payments and issue invoices</li>
    <li>Investigate complaints, incidents, or safety concerns</li>
    <li>Improve service quality and operational efficiency</li>




</ul>

 </div>

 <div className={styles.terms__section}>
    <h2>5. Legal Basis for Processing
</h2>

<p>
    We process personal data under the following UK GDPR legal bases:

</p>

<ul>
    <li>Contractual necessity – to provide requested private hire services
</li>
<li>	Legal obligation – TfL, HMRC, and regulatory compliance
</li>
<li>Legitimate interests – safety, security, fraud prevention, and dispute resolution
</li>
<li>Consent – marketing communications where applicable
</li>
</ul>

 </div>

 <div className={styles.terms__section}>
    <h2>6. TfL & PCO Compliance
</h2>

<p>To meet TfL Private Hire Operator requirements, Chauffeur Rides Ltd:
</p>
 <ul>
    <li>Retains booking and journey data for required periods
</li>
<li>Shares necessary booking details only with licensed PCO drivers
</li>
<li>Provides data to TfL, police, or authorised bodies upon lawful request
</li>
<li>Ensures passenger data is accessed only by authorised personnel
</li>
 </ul>

 </div>

<div className={styles.terms__section}>
    <h2>7. Sharing Personal Data
</h2>
<p>We may share personal data with:
</p>
<ul>
    <li>Transport for London (TfL) and regulatory authorities
</li>
<li>Licensed private hire drivers working with Chauffeur Rides Ltd</li>
<li>Payment processors</li>
<li>Booking and dispatch software providers</li>
<li>Legal, insurance, or compliance advisors</li>


</ul>

<p>We do not sell personal data to third parties.
</p>

</div>

<div className={styles.terms__section}>
    <h2>8. CCTV & Dashcam Policy (If Installed)
</h2>
<p>Some vehicles operated by Chauffeur Rides Ltd may be fitted with CCTV or dashcams for safety and security purposes.
</p>
<ul>
    <li>	Cameras are clearly signposted inside vehicles</li>
    <li>Recordings are used only for safety, complaints, or legal matters</li>
    <li>Access to footage is restricted to authorised personnel</li>
    <li>Footage is retained for a maximum of 30 days, unless required for investigation</li>
    <li>Footage may be shared with TfL or law enforcement when legally required</li>

</ul>
<p>Passengers may request access to CCTV footage in line with UK GDPR.
</p>
</div>

<div className={styles.terms__section}>
    <h2>9. Data Retention
</h2>
<p>We retain personal data only for as long as necessary:
</p>
<ul>
    <li>Booking & journey records: minimum 12 months, up to 6 years</li>
    <li>Payment and invoicing records: 6 years
</li>
<li>CCTV footage: up to 30 days (unless required longer)</li>
<li>Marketing data: until consent is withdrawn
</li>
</ul>
</div>


<div className={styles.terms__section}>
    <h2>10. International Data Transfers
</h2>

<p>If personal data is processed outside the UK, appropriate safeguards are applied in accordance with UK GDPR requirements.
</p>
    

</div>

<div className={styles.terms__section}>
    <h2>11. Your Data Protection Rights
</h2>
<p>You have the right to:
</p>
<ul>
    <li>Access your personal data
</li>
<li>Request correction or deletion
</li>
<li>Restrict or object to processing
</li>
<li>Data portability
</li>
<li>Withdraw consent at any time
</li>
<li>Lodge a complaint with the Information Commissioner’s Office (ICO)
</li>
</ul>


</div>

<div className={styles.terms__section}>
    <h2>12. Data Security
</h2>

<p>We use appropriate technical and organisational measures to protect personal data, including:
</p>

<ul>
    <li>Secure booking and dispatch systems
</li>
<li>Encrypted payment processing
</li>
<li>Limited access to personal data
</li>
<li>Confidentiality obligations for staff and drivers
</li>
</ul>
</div>

<div className={styles.terms__section}>
    <h2>13. Marketing Communications
</h2>

<p>
    Marketing communications are sent only where consent has been provided. You can opt out at any time by using the unsubscribe link or contacting us directly.

</p>

</div>

<div className={styles.terms__section}>
    <h2>14. Changes to This Policy
</h2>

<p>We may update this Privacy Policy from time to time. The most recent version will always be available on our website.
</p>


</div>

<div className={styles.terms__section}>
    <h2>15. Contact Us
</h2>
<p>
For any privacy or data protection enquiries:</p>

    
</div>

<div className={styles.terms__companyInfo}>
    <span>Email:</span>Chauffeurridesltd@hotmail.com 



</div>

<div className={styles.terms__companyInfo}>
    <span>Telephone:</span>  07943152288



</div>































































    </div>

</div>
























































    )
}

export default PrivacyAndPolicy;